var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"diy-topbar"},[_c('TheTopbarLogo'),_c('TheTopbarNavbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }